import { useEffect } from "react";

export default function useHandleNewGameState({
    newGameState,
    setNewGameState,
    setGameState,
    networkRef,
    notice,
    pulseNodeTimerRef,
    answerNotificationTimerRef,
    taskQueue,
    topic
}) {
    useEffect(() => {
        if (JSON.stringify(newGameState) === "{}") return;


        // Update game session periodically, unless the game ended
        let updateSessionTimeout;
        taskQueue.start();
        
        // Merge new state
        setGameState((prev) => ({ ...prev, ...newGameState }));

        return () => {
            if (updateSessionTimeout) clearTimeout(updateSessionTimeout);
        };
    }, [newGameState, taskQueue, setGameState]);
}
